import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merges class names, with later Tailwind utilities winning over earlier ones
 * in the same group. `cn("p-2", "p-4")` yields `p-4` rather than both — which
 * is what makes a `className` prop on a component actually able to override
 * the component's own padding.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
